import React from 'react';
import InputSync from 'components/InputSync';
import styles from 'components/InputDarkBackground.css';
import stylesProgressBar from 'components/syncingInputProgressBarWhite.css';

const InputDarkBackground = props =>
  <InputSync
    inputTheme={styles}
    progressBarTheme={stylesProgressBar}
    {...props}
  />;

export default InputDarkBackground;
